import { useEffect, useRef, useState } from 'react';


function useVersionCheck(interval = 120000) {

        const [version, setVersion] = useState(null);
        const [updateAvailable, setUpdateAvailable] = useState(false);
        const currentVersion = useRef(null);

        useEffect(() => {
                if (process.env.NODE_ENV !== 'production') return;
                if ('serviceWorker' in navigator) {
                        navigator.serviceWorker.getRegistrations().then((regs) => {
                                regs.forEach((reg) => reg.unregister());
                        });
                }

                const fetchVersion = async () => {
                        try {
                                const response = await fetch('/meta.json', { cache: 'no-store' });
                                const data = await response.json();
                                const remoteVersion = data.version;
                                if (!currentVersion.current) {
                                        currentVersion.current = remoteVersion;
                                        setVersion(remoteVersion);
                                        return;
                                }

                                if (currentVersion.current !== remoteVersion) {
                                        setUpdateAvailable(true);
                                }

                        } catch (error) {
                                console.error('Version check failed', error);
                        }
                };

                fetchVersion();
                const intervalId = setInterval(fetchVersion, interval);

                return () => clearInterval(intervalId);
        }, [interval]);

        const reloadPage = () => {
                // const url = new URL(window.location.href);
                // url.searchParams.set('v', Date.now());
                // window.location.replace(url.toString());
                window.location.reload(true);
        };

        return { version, updateAvailable, reloadPage };
}

export default useVersionCheck;
